import React from 'react'
import { Outlet } from 'react-router-dom'
import { IProduct } from '../../types/products'
import { useRouteKind } from '../../utils/useRouteKind'
import './InfoLayout.scss'

type Props = {
  cart: IProduct[]
  setCart: (cart: IProduct[]) => void
}
const c = 'info-layout'

const InfoLayout = ({ cart, setCart }: Props) => {
  const route = useRouteKind()

  return (
    <div className={`${c}${route === 'checkout' ? ` ${c}--wide` : ''}`}>
      <Outlet context={{ cart, setCart }} />
    </div>
  )
}

export default InfoLayout
